var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 100,
    viewBox: "0 0 52 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24594 -0.00178622C1.66888 -0.00178632 1.09181 0.220192 0.657231 0.664159C-0.219054 1.54493 -0.219054 2.97708 0.65723 3.86502L46.566 50.0018L0.657214 96.1386C-0.219071 97.0193 -0.219071 98.4515 0.657214 99.3394C1.5335 100.22 2.95835 100.22 3.84176 99.3394L51.3392 51.5986C51.7596 51.1762 51.9947 50.5961 51.9947 50.0018C51.9947 49.4003 51.7596 48.8274 51.3392 48.4049L3.83465 0.657003C3.40007 0.213035 2.82301 -0.00178612 2.24594 -0.00178622Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.3d9db2956591d0eaf4789f6e8b83cd1f.svg";
export { ForwardRef as ReactComponent };